export class ZoneOccupationData {
  occupation = 0;
  maxOccupation = 0;
}
